var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconMail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 19 13.538"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3",
    d: "M18.371.207L9.522 8.725.51.325a1.271 1.271 0 01.691-.31 2.477 2.477 0 01.311-.013h16.037a1.376 1.376 0 01.822.205z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4",
    d: "M6.742 7.829l.783.725 1.528 1.422a.625.625 0 00.962-.011q1.1-1.051 2.19-2.1l.125-.114 6.009 5.605a1.273 1.273 0 01-.713.186H1.517c-.192 0-.384-.034-.576-.053l-.009-.055z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5",
    d: "M5.821 6.984L.048 12.538a3.116 3.116 0 01-.046-.361v-10.5c0-.025 0-.049.007-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 6",
    d: "M18.997 12.287l-5.789-5.4 5.789-5.574z"
  }))));
}

export default __webpack_public_path__ + "cf472edd49267d98c469404c181750b2.svg";
export { SvgIconMail as ReactComponent };